export default __webpack_public_path__ + "static/videoPlaceholder-e4964967fd11ba8fea435a12df62c4cb.webp";